// extracted by mini-css-extract-plugin
export default {"module":"MultiField_module__5uaUc","item":"MultiField_item__99wBp"};